var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZambia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#408926",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e18430",
    d: "M30 24h-5V11h5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20 11h5v13h-5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd3421",
    d: "M15 11h5v13h-5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e18430",
    d: "M28.05 5.15q-.04-.04-.34.1c.98-.86.31-.58-.26-.22 1.13-1.03.01-.54-.55-.17 1.33-1.07-.46-.07-1.16.16.6-.64-1.3.22-1.58.16-.56.29-2 .15-2.04.27-.27-.37.34-.63.4-.34.5-.59-1.61-.95-1.6.23-.61.13-3.56-1.4-2.41-.36-.68-.34-2.61-1.32-1.3-.08-.71-.35-1.37-.9-.65.06-.46-.43-.62-.19-.13.2-.73-.51-.32.4.92.63-.43.04-.07.3.57.25-1.02.11.12.42.57.25-.74.09-.38.43.75.18-.76.14-.26.44.25.3-.33.2.28.17.42.12-.11.06-.11.07-.1.09.15.13.49 0 .57-.05-.34.3.27.2.54.08-.44.3.45.4.58.29 0 .05-.06.16 0 .14l.08-.07c-.08.2-.24.86.08.41-.03.23-.07.3.04.28.01.24-.7.24-.63.5-.08.25.13.06.4 0-.09.41.08.49.32.12.28.43.21.36.34-.03.08.13.13.07.1-.05q.05.02.18-.06c0 .17-.03.35.19.38.01-.1-.07-.13.07-.21.1-.12-.03-.45.16-.14.16.03.1.05.11.15.47 0-.13-.7.25-.39.13.07.02-.2-.1-.2-.23-.02-.17.01-.2-.13.6.3.09-.18.07-.38.32.23.38.15.08-.13.05.05.44.3.43.09.5.3.74.03.16-.27.23.21 1.33.44.64-.06.1.08.66-.01.44-.13.24 0 .52-.09.22-.18.55-.04.87-.21.93-.33 1.44-.16 2.17-1.05 1.72-.93.29-.25.49-.36.47-.53m-5.85 3.1c-.18-.05-.19-.16-.16-.38.28.32.07-.5.15-.78.35.36.15.94.36.9.08.3-.17.16-.35.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZambia);
export default __webpack_public_path__ + "static/media/zambia.48a650df8a94f5da38c5662050ec0d3c.svg";
export { ForwardRef as ReactComponent };